import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    limit: 20,
    page: 1,
    total: 0,
    totalPages: 1,
};

export const brandPageSlice = createSlice({
    name: "brandPageSlice",
    initialState,
    reducers: {
        setBrandPageLimit: (state, action) => {
            state.limit = action.payload;
        },
        setBrandCurrentPage: (state, action) => {
            state.page = action.payload;
        },
        setBrandTotalCount: (state, action) => {
            state.total = action.payload;
        },
        setBrandTotalPages: (state, action) => {
            state.totalPages = action.payload;
        },
        resetBrandPagination: (state, action) => {
            state.limit = 20;
            state.page = 1;
            state.total = 0;
            state.totalPages = 1;
        },
    },
});

export const {
    setBrandPageLimit,
    setBrandCurrentPage,
    setBrandTotalCount,
    setBrandTotalPages,
    resetBrandPagination,
} = brandPageSlice.actions;

export default brandPageSlice.reducer;